<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-model="query.agentId" filterable clearable placeholder="请选择代理" class="handle-select mr10">
					<el-option v-for="item in agents" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>

				<el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button size="small" type="primary" icon="el-icon-add  el-icon--right" class="handle-add mr100" @click="showForm">添加代理</el-button>
			</div>

			<el-table
				:data="tableData"
				border
				class="table"
				ref="multipleTable"
				header-cell-class-name="table-header"
				:row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }"
				:row-class-name="tableRowClassName"
			>
				<el-table-column prop="id" width="240" label="代理id" align="center"></el-table-column>
				<el-table-column prop="name" width="280" label="企业名称" align="center"></el-table-column>
				<el-table-column prop="code" width="220" label="企业代码" align="center"></el-table-column>
				<el-table-column prop="ownerName" label="负责人" align="center"></el-table-column>
				<el-table-column prop="ownerPhone" label="负责人联系电话" align="center"></el-table-column>
				<el-table-column prop="validCallTime" label="可分配时长(月)" align="center"></el-table-column>
				<el-table-column prop="open" label="是否可用" align="center">
					<template #default="scope">
						<el-tag :type="scope.row.open === '是' ? 'success' : scope.row.open === '否' ? 'danger' : ''">{{ scope.row.open }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="interior" label="内部代理" align="center">
					<template #default="scope">
						<el-tag type="success" v-if="scope.row.interior == true">是</el-tag>
						<el-tag type="danger" v-if="scope.row.interior == false">否</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180" align="center">
					<template #default="scope">
						<el-button size="small" type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row.id)">编辑</el-button>
						<el-button size="small" type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index, scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination
					background
					layout="total, prev, pager, next"
					:current-page="query.pageIndex"
					:page-size="query.pageSize"
					:total="pageTotal"
					@current-change="handlePageChange"
				></el-pagination>
			</div>
		</div>

		<el-dialog title="代理编辑" v-model="addVisible" width="500px" @close="closeDialog('form')" :close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px">
				<el-form-item label="企业名称" prop="name"><el-input size="small" v-model="form.name"></el-input></el-form-item>
				<el-form-item label="企业代码" prop="code"><el-input size="small" v-model="form.code"></el-input></el-form-item>

				<el-form-item label="负责人" prop="ownerName"><el-input size="small" v-model="form.ownerName"></el-input></el-form-item>
				<el-form-item label="联系方式" prop="ownerPhone"><el-input size="small" v-model="form.ownerPhone"></el-input></el-form-item>

				<el-form-item label="通话时长">
					<el-input-number size="small" style="width: 200px" v-model="form.validCallTime">月</el-input-number>
					(月)
				</el-form-item>
				<el-form-item label="内部代理" prop="interior"><el-switch v-model="form.interior" active-color="#13ce66" inactive-color="#ff4949"></el-switch></el-form-item>
				<el-form-item label="启用" prop="enable"><el-switch v-model="form.enable" active-color="#13ce66" inactive-color="#ff4949"></el-switch></el-form-item>
			</el-form>
			<span class="dialog-footer myRight">
				<el-button size="small" @click="closeDialog('form')">取消</el-button>
				<el-button size="small" v-if="addButton" type="primary" @click="addAgent('form')">确定</el-button>
				<el-button size="small" v-if="updateButton" type="primary" @click="updateAgent('form')">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { list, delAgent, addAgent, updateAgent, fetchAgentById, fetchAgent } from '../api/agentIndex.js';

export default {
	name: 'agent',
	data() {
		return {
			query: {
				agentId: '',
				pageIndex: 1,
				pageSize: 30
			},
			tableData: [],
			agents: [],
			multipleSelection: [],
			delList: [],
			editVisible: false,
			addVisible: false,
			addButton: false,
			updateButton: false,
			pageTotal: 0,
			selectForm: {
				region: 0
			},
			form: {
				name: '',
				code: '',
				ownerName: '',
				ownerPhone: '',
				validCallTime: 0,
				enable: false,
				interior: false
			},
			idx: -1,
			id: -1,
			loading: false,
			token: { Authorization: localStorage.getItem('token') },
			rules: {
				name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
				code: [{ required: true, message: '请输入企业代码', trigger: 'blur' }],
				ownerName: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
				ownerPhone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }]
			}
		};
	},
	created() {
		this.init();
	},
	methods: {
		tableRowClassName({ rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return 'oddRow';
			}
			return 'evenRow';
		},
		init() {
			fetchAgent(localStorage.getItem('user')).then(res => {
				this.agents = res.data;
			});
		},
		getData() {
			this.query.currentUserId = localStorage.getItem('user');
			list(this.query).then(res => {
				if (res.code === 200) {
					this.tableData = res.data.list;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		showForm() {
			this.addVisible = true;
			this.addButton = true;
			this.updateButton = false;
		},
		addAgent(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loading = true;
					this.form.userId = localStorage.getItem('user');
					addAgent(this.form).then(res => {
						if (res.code === 200) {
							this.$message.success('添加成功');
							this.getData();
						}
						this.addVisible = false;
					});
				}
			});
		},
		// 编辑操作
		handleEdit(index, id) {
			this.addVisible = true;
			this.idx = index;
			this.addButton = false;
			this.updateButton = true;
			// 获取详情
			fetchAgentById(id).then(res => {
				this.form = res.data;
			});
		},
		updateAgent(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loading = true;
					this.form.userId = localStorage.getItem('user');
					updateAgent(this.form).then(res => {
						if (res.code === 200) {
							this.$message.success('修改成功');
							this.getData();
						} else {
							this.$message.error(res.message);
						}
						this.addVisible = false;
					});
				}
			});
		},
		// 触发搜索按钮
		handleSearch() {
			this.query.pageIndex = 1;
			this.getData();
		},
		// 删除操作
		handleDelete(index, id) {
			// 二次确认删除
			this.$confirm('确定要删除吗？', '提示', {
				type: 'warning'
			})
				.then(() => {
					delAgent(id).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.pageTotal = this.pageTotal - 1;
							this.tableData.splice(index, 1);
						} else {
							this.$message.error(res.message);
						}
					});
				})
				.catch(() => {});
		},
		// 分页导航
		handlePageChange(val) {
			this.query.pageIndex = val;
			this.getData();
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		closeDialog(formName) {
			this.addVisible = false;
			(this.form = {
				name: '',
				code: '',
				ownerName: '',
				ownerPhone: ''
			}),
				this.resetForm(formName);
		}
	}
};
</script>

<style scoped>
.handle-box {
	margin-bottom: 20px;
}

/* a:hover{background: #66b1ff} */
.handle-select {
	width: 240px;
}

.table {
	width: 100%;
	font-size: 14px;
}
.red {
	color: #f56c6c;
}
.mr10 {
	margin-right: 10px;
}

.mr100 {
	position: absolute;
	right: 100px;
}

.myRight {
	position: absolute;
	right: 10px;
	bottom: 10px;
}

.handle-input {
	width: 200px;
	display: inline-block;
}
</style>
